<div class="main-section">
  <div aria-live="assertive" aria-atomic="true" class="sr-only">{{ screenReaderAnnouncement }}</div>
  <mat-icon class="message-icon">schedule</mat-icon>
  <h1 class="message-header">You will be logged out in {{ timeLeft }} seconds</h1>
  </div>

  <div mat-dialog-actions align="center" class="actions">
    <button mat-stroked-button (click)="logout()">
      {{ isGuestAllow ? "Continue as Guest" : "Log me out" }}
    </button>
    <button mat-flat-button color="primary" (click)="stayLogin()">
      Stay Logged In
    </button>
  </div>
